import Vue from 'vue';
import AdminLayout from '@/views/Layout/AdminLayout.vue';
import SlLayout from '@/views/Layout/SlLayout.vue'
import UserLayout from '@/views/Layout/UserLayout.vue';
import NotFound from '@/views/Pages/NotFoundPage.vue';
import LegalNotice from '@/views/Pages/LegalNotice.vue';

const routes = [
  {
    path: '/home',
    component: UserLayout,
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/Pages/UserPages/HomePage.vue'),
        meta: { title: Vue.i18n.translate('title.home') }
      },
      {
        path: '/tools',
        name: 'tools',
        component: () => import('../views/Pages/UserPages/ToolsPage.vue'),
        meta: { title: Vue.i18n.translate('title.tools') }
      },  
      {
        path: '/share',
        name: 'share',
        component: () => import('../views/Pages/UserPages/SharePage.vue'),
        meta: { title: Vue.i18n.translate('title.share') }
      },
      {
        path: '/cooptation',
        name: 'cooptation',
        component: () => import('../views/Pages/UserPages/CooptationPage.vue'),
        meta: { title: Vue.i18n.translate('title.cooptation') }
      },
      {
        path: '/actus',
        name: 'actus',
        component: () => import('../views/Pages/UserPages/ActusPage.vue'),
        meta: { title: Vue.i18n.translate('title.actus') }
      }
    ]
  }, 
  {
    path: '/blogs',
    component: AdminLayout,
    children: [
      {
        path: '/blogs/:id',
        name: 'New blog',
        component: () => import('../views/Pages/AdminPages/Blog/BlogPage.vue'),
        meta: {
          title: Vue.i18n.translate('title.addblog'),
          admin: true
        }
      },
      {
        path: '/blogs',
        name: 'Blogs',
        component: () => import('../views/Pages/AdminPages/Blogs/BlogsPage.vue'),
        meta: {
          title: Vue.i18n.translate('title.blogs'),
          admin: true
        }
      },
      {
        path: '/admin/meetup',
        name: 'Meet-up',
        component: () => import('../views/Pages/AdminPages/Meetup/MeetupsPage.vue'),
        meta: {
          title: Vue.i18n.translate('title.meetup'),
          adminServiceLines: true
        }
      },
      {
        path: '/admin/meetup/:id',
        name: 'New Meet-up',
        component: () => import('../views/Pages/AdminPages/Meetup/MeetupPage.vue'),
        meta: {
          title: Vue.i18n.translate('title.addmeetup'),
          adminServiceLines: true
        }
      },           
      {
        path: '/users',
        name: 'Users',
        component: () => import('../views/Pages/AdminPages/Users/UsersPage.vue'),
        meta: {
          title: Vue.i18n.translate('title.users'),
          admin: true,
          adminServiceLines : true
        }
      }
    ]
  },
  {
    path: '/meetup',
    component: SlLayout,
    children: [
      {
        path: '/meetup',
        name: 'Service lines',
        component: () => import('../views/Pages/ServiceLinesPages/MeetUp.vue'),
        meta: {
          title: Vue.i18n.translate('sl.title.home'),
        }
      },
      {
        path: '/servicelines',
        redirect: '/meetup'
      },     
      {
        path: '/meet-up',
        redirect: '/meetup'
      },        
      {
        path: '/slitdigitalexperience',
        name: 'DIGITAL & DATA',
        component: () => import('../views/Pages/ServiceLinesPages/ITDigitalExperience.vue'),
        meta: {
          title: Vue.i18n.translate('sl.title.itandxpdigitale'),
        }
      },
      {
        path: '/slinfrastructurecybersecurity',
        name: 'TELECOM & INFRA',
        component: () => import('../views/Pages/ServiceLinesPages/InfrastructureCybersecurity.vue'),
        meta: {
          title: Vue.i18n.translate('sl.title.infrastructure'),
        }
      },
      {
        path: '/slintelligentsystems',
        name: 'SMART INDUSTRY',
        component: () => import('../views/Pages/ServiceLinesPages/IntelligentSystems.vue'),
        meta: {
          title: Vue.i18n.translate('sl.title.si'),
        }
      },
      {
        path: '/play',
        name: 'PLAY',
        component: () => import('../views/Pages/ServiceLinesPages/Play.vue'),
        meta: {
          title: Vue.i18n.translate('sl.title.play'),
        }
      }                     
    ]
  },                               
  {
    path: '/',
    redirect: 'home'
  }, 
  {
      path: '/login',
      name: 'login',
      component: () => import('../views/Pages/Login.vue'),
      meta: {
        title: Vue.i18n.translate('title.login'),
        noAuth: true
      }
  },
  {
    path: '/legalnotice',
    component: LegalNotice,
    meta: { title: Vue.i18n.translate('title.legalnotice') }
  },
  {
    path: '*',
    component: NotFound,
    meta: { title: Vue.i18n.translate('title.notfound') }
  }
];

export default routes;
